export const makeFormInputDefaultProps = (focusBorderColor?: string) => ({
  _placeholder: { color: "blueGray.500" },
  _focus: {
    borderColor: focusBorderColor || "transparent",
  },
  border: "none",
  shadow: "sm",
});
